import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { Checkbox } from '@patternfly/react-core';
import { getUniqueId } from '../../helpers/util';
export const FilterSidePanelCategoryItem = (_a) => {
    var { children = null, className = '', icon = null, count = null, onClick = null, checked = false, title = '' } = _a, props = __rest(_a, ["children", "className", "icon", "count", "onClick", "checked", "title"]);
    const classes = css('filter-panel-pf-category-item', className);
    const label = (React.createElement(React.Fragment, null,
        icon && React.createElement("span", { className: "item-icon" }, icon),
        children,
        Number.isInteger(count) && React.createElement("span", { className: "item-count" }, `(${count})`)));
    return (React.createElement("div", Object.assign({ className: classes }, props),
        React.createElement(Checkbox, { onClick: onClick, checked: checked, id: getUniqueId(), label: label, title: title })));
};
FilterSidePanelCategoryItem.displayName = 'FilterSidePanelCategoryItem';
export default FilterSidePanelCategoryItem;
//# sourceMappingURL=FilterSidePanelCategoryItem.js.map